import React, { Component } from "react";
import ScheduleEntryTitle from "../core/ScheduleEntryTitle";
import styled from "styled-components";

const MainWrapper = styled.div``;
class MainDashboard extends Component {
  componentDidMount() {
    this.props.updateMenu("dashboard", "Dashboard");
  }
  render() {
    return (
      <MainWrapper>
        <ScheduleEntryTitle />
      </MainWrapper>
    );
  }
}

export default MainDashboard;
